import { spreeIntegration } from '@Root/spree';

spreeIntegration();

import '@Root/blocks';
